<template>
<v-card flat>
    <v-card-title>
      <div>
        <h3 class="subheading">Create Integration</h3>
        <div class="caption grey--text">{{responsename}}</div>
      </div>
      <v-spacer></v-spacer> 
                <v-btn icon @click="cancelCard"><v-icon>clear</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-container class="scroll-y" style="max-height:400px" grid-list-xl>
          <v-layout class="mt-0" row wrap>                       
            <v-flex class="mt-0" xs12>
              <v-select
                  :items="integrationTypes"
                  label="Integration Type"
                  v-model="integrationType"
              ></v-select>                                                    
            </v-flex>                        
          </v-layout>
          <v-layout class="mt-0" row wrap>                       
            <v-flex class="mt-0" xs12>
              <v-textarea
                auto-grow
                v-model="shortNote"
                label="Short Note"                
                placeholder="short note to remember the integration"
                counter="500"
                rows="1"
                class="body-1 font-weight-regular"
              ></v-textarea>                                                     
            </v-flex>                        
            </v-layout>
            <v-layout v-if="integrationType == 'Email'" class="mt-0" row wrap>                       
              <v-flex class="mt-0" xs12>
                <v-textarea
                  auto-grow
                  v-model="emailSubject"
                  label="Email Subject"                
                  placeholder="Write your email subject"
                  counter="300"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>                        
            </v-layout> 
            <v-layout v-if="integrationType == 'Email'" class="mt-0" row wrap>                       
              <v-flex class="mt-0" xs6>
                <v-textarea
                  auto-grow
                  v-model="emailFrom"
                  label="Email From"                
                  placeholder="Write the from email address"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>
              <v-flex class="mt-0" xs6>
                <v-textarea
                  auto-grow
                  v-model="emailTo"
                  label="Email To"                
                  placeholder="Write the to email address"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>                        
            </v-layout>
            <v-layout v-if="integrationType == 'Email'" class="mt-0" row wrap>                       
              <v-flex class="mt-0" xs12>
                <v-textarea
                  auto-grow
                  v-model="emailBody"
                  label="Email Body"                
                  placeholder="Write the email body"
                  counter="2000"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>                        
            </v-layout>  
            <v-layout v-if="integrationType == 'Email'" class="mt-0" row wrap>                       
              <v-flex class="mt-0" xs12>
                <v-textarea
                  auto-grow
                  v-model="emailBodyHtml"
                  label="Email Body HTML"                
                  placeholder="Write the email body in HTML"
                  counter="3000"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>                        
            </v-layout>
            <v-layout v-if="integrationType == 'Google Sheets'" class="mt-0" row wrap>                       
              <v-flex class="mt-0" xs12>
                <v-textarea
                  auto-grow
                  v-model="gsheetName"
                  label="Google Sheet Name"                
                  placeholder="Enter the google sheet name to create"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>
              <!-- <v-flex class="mt-0" xs3>
                <v-btn round flat color="primary" @click="validateSheet">Validate</v-btn>
              </v-flex>                           -->
            </v-layout>
            <v-layout v-for="(gsheetcolumn,index) in gsheetcolumns" class="mt-0" :key="index" row wrap>                       
              <v-flex v-if="integrationType == 'Google Sheets'" class="mt-0" xs5>
                <v-textarea
                  auto-grow
                  v-model="gsheetcolumn.name"
                  label="Column Name"                
                  placeholder="Write the column name"
                  rows="1"
                  class="body-1 font-weight-regular"
                  disabled
                ></v-textarea>                                                     
              </v-flex>
              <v-flex v-if="integrationType == 'Google Sheets'" class="mt-0" xs5>
                <v-textarea
                  auto-grow
                  v-model="gsheetcolumn.value"
                  label="Column value"                
                  placeholder="Write the column value"
                  rows="1"
                  class="body-1 font-weight-regular"
                  disabled
                ></v-textarea> 
              </v-flex>
              <v-flex v-if="integrationType == 'Google Sheets' && index == gsheetcolumns.length-1" class="mt-0" xs2>
                <v-btn round flat color="primary" @click="deleteColumn(index)">Delete</v-btn>
              </v-flex>                       
            </v-layout>
            <v-layout v-if="integrationType == 'Google Sheets'" class="mt-0" row wrap>                       
              <v-flex class="mt-0" xs5>
                <v-textarea
                  auto-grow
                  v-model="gsheetcolumnName"
                  label="Column Name"                
                  placeholder="Write the column name"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>
              <v-flex class="mt-0" xs5>
                <v-textarea
                  auto-grow
                  v-model="gsheetcolumnValue"
                  label="Column value"                
                  placeholder="Write the column value"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea> 
              </v-flex>
              <v-flex class="mt-0" xs2>
                <v-btn round flat color="primary" @click="addColumn">Add</v-btn>
              </v-flex>                        
            </v-layout> 
            <v-layout class="mt-0" v-if="integrationType == 'API'" row wrap>                       
            <v-flex class="mt-0" xs12>
              <v-select
                  :items="APItypes"
                  label="API Type"
                  v-model="APItype"
              ></v-select>                                                    
            </v-flex>                        
          </v-layout>
          <v-layout v-if="integrationType == 'API'" class="mt-0" row wrap>                       
              <v-flex class="mt-0" xs12>
                <v-textarea
                  auto-grow
                  v-model="apiURL"
                  label="API URL"                
                  placeholder="Enter the API URL"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>                        
            </v-layout>
          <v-layout v-for="(apiHeaderData,index) in apiHeaders" class="mt-0" :key="index" row wrap>                       
              <v-flex v-if="integrationType == 'API'" class="mt-0" xs5>
                <v-textarea
                  auto-grow
                  v-model="apiHeaderData.name"
                  label="Header Name"                
                  placeholder="Write the Header name"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>
              <v-flex v-if="integrationType == 'API'" class="mt-0" xs5>
                <v-textarea
                  auto-grow
                  v-model="apiHeaderData.value"
                  label="Header value"                
                  placeholder="Write the Header value"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea> 
              </v-flex>
              <v-flex v-if="integrationType == 'API'" class="mt-0" xs2>
                <v-btn round flat color="primary" @click="deleteHeader(index)">Delete</v-btn>
              </v-flex>                      
            </v-layout>
          <v-layout v-if="integrationType == 'API'" class="mt-0" row wrap>                       
              <v-flex class="mt-0" xs5>
                <v-textarea
                  auto-grow
                  v-model="apiHeaderName"
                  label="Header Name"                
                  placeholder="Write the Header name"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>
              <v-flex class="mt-0" xs5>
                <v-textarea
                  auto-grow
                  v-model="apiHeaderValue"
                  label="Header value"                
                  placeholder="Write the Header value"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea> 
              </v-flex>
              <v-flex class="mt-0" xs2>
                <v-btn round flat color="primary" @click="addHeader">Add</v-btn>
              </v-flex>                        
            </v-layout> 
            <v-layout v-for="(apiParamData,index) in apiParams" class="mt-0" :key="index" row wrap>                       
              <v-flex v-if="integrationType == 'API'" class="mt-0" xs5>
                <v-textarea
                  auto-grow
                  v-model="apiParamData.name"
                  label="Parameter Name"                
                  placeholder="Write the Parameter name"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>
              <v-flex v-if="integrationType == 'API'" class="mt-0" xs5>
                <v-textarea
                  auto-grow
                  v-model="apiParamData.value"
                  label="Parameter value"                
                  placeholder="Write the Parameter value"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea> 
              </v-flex>
              <v-flex v-if="integrationType == 'API'" class="mt-0" xs2>
                <v-btn round flat color="primary" @click="deleteParam(index)">Delete</v-btn>
              </v-flex>                     
            </v-layout>
          <v-layout v-if="integrationType == 'API'" class="mt-0" row wrap>                       
              <v-flex class="mt-0" xs5>
                <v-textarea
                  auto-grow
                  v-model="apiParamName"
                  label="Parameter Name"                
                  placeholder="Write the Paramer name"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>
              <v-flex class="mt-0" xs5>
                <v-textarea
                  auto-grow
                  v-model="apiParamValue"
                  label="Parameter value"                
                  placeholder="Write the Parameter value"
                  rows="1"
                  class="body-1 font-weight-regular"
                ></v-textarea> 
              </v-flex>
              <v-flex class="mt-0" xs2>
                <v-btn round flat color="primary" @click="addParam">Add</v-btn>
              </v-flex>                        
            </v-layout>
            <v-layout v-if="integrationType == 'API'" class="mt-0" row wrap>                       
              <v-flex class="mt-0" xs12>
                <v-textarea
                  auto-grow
                  v-model="apiBody"
                  label="API Json Body"                
                  placeholder="Enter the API Json Body"
                  rows="2"
                  class="body-1 font-weight-regular"
                ></v-textarea>                                                     
              </v-flex>                        
            </v-layout>                
        </v-container>
        <v-card-actions class="ma-0">
            <v-spacer></v-spacer>                  
                <v-btn round flat color="primary" @click="cancelCard">Cancel</v-btn>
                <v-btn round flat color="primary" @click="saveCard">Save</v-btn>                
        </v-card-actions>
        <v-snackbar
            v-model="snackbar.status"
            bottom
            left
            :timeout="snackbar.timeout"
            >
            {{snackbar.update}}
        </v-snackbar>  
        </v-card>
</template>

<script>
import axios from 'axios'
import store from '../store'
export default {
  data(){
    return{
      shortNote:null,
      type:"integration",
      integrationTypes:['Email','Google Sheets','API'],
      APItypes:['GET','POST'],
      integrationType:null,
      APItype:null,
      integrationTypeChoice:null,
      emailFrom:null,
      emailTo:null,
      emailSubject:null,
      emailBody:null,
      emailBodyHtml:null,
      gsheetName:null,
      gsheetcolumnName:null,
      apiHeaderName:null,
      apiParamName:null,
      gsheetcolumnValue:null,
      apiHeaderValue:null,
      apiParamValue:null,
      gsheetcolumns:[],
      apiHeaders:[],
      apiParams:[],
      gsheetcolumnNames:[],
      apiURL:null,
      apiBody:null
    }
  },
  methods:{
    saveCard(){
       let index = this.$store.state.currentResponseIndex
       if (this.integrationType == 'Email'){
          let email = {"from":this.emailFrom,"to":this.emailTo,"subject":this.emailSubject,"body":this.emailBody,"body_html":this.emailBodyHtml}
          let intDetails = {"integration_type":this.integrationType,"integration_type_choice":this.integrationTypeChoice,"short_note":this.shortNote,"email":email}
          let message = {"integration_details":intDetails,"type":"integration"}      
          this.$store.dispatch('acreateresponseMessage', {index,message})
       }
       else if (this.integrationType == 'Google Sheets'){
          let pageid = this.$route.params.page_id;
          let sheet_name = this.gsheetName;
          let sheet_columns = this.gsheetcolumns;
          let column_names = this.gsheetcolumnNames;
          let integration_type = this.integrationType
          let integration_type_choice = this.integrationTypeChoice
          let short_name = this.shortNote
          let status = true
          let timeout = 0
          let update = "Creating Google sheet..."
          store.dispatch('aupdatesnackbarstatus',{status,update,timeout})
          let res1 = axios({
                    method: "post",
                    url: "https://small-umbra.glitch.me/createGoogleSheet",
                    data: {column_names},
                    params: {pageid,sheet_name,column_names}
                })
            .then(response => {
                console.log(response)
                let sheetId = response.data.sheetId
                let gsheets = {"name":sheet_name, "sheetId":sheetId, "columnValues":sheet_columns}
                let intDetails = {"integration_type":integration_type,"integration_type_choice":integration_type_choice,"short_note":short_name,"gsheets":gsheets}
                let message = {"integration_details":intDetails,"type":"integration"}      
                store.dispatch('acreateresponseMessage', {index,message})
                status = false
                timeout = 1000
                update = "Google sheet created"
                store.dispatch('aupdatesnackbarstatus',{status,update,timeout})
                store.dispatch('aresponsemenuStatusChange',status)
            })
            .catch(error => {
            console.log(error)
            })
       }
      //  else if (this.integrationType == 'API'){

      //  }

      this.text = null
      // let status = false
      // this.$store.dispatch('aresponsemenuStatusChange',status)
    },
    cancelCard(){
      let status = false
      this.$store.dispatch('aresponsemenuStatusChange',status)
    },
    addColumn(){
      this.gsheetcolumns.push({name:this.gsheetcolumnName,value:this.gsheetcolumnValue})
      this.gsheetcolumnNames.push(this.gsheetcolumnName)
      this.gsheetcolumnName = null
      this.gsheetcolumnValue = null
      console.log(this.gsheetcolumnNames)
    },
    addHeader(){
      this.apiHeaders.push({name:this.apiHeaderName,value:this.apiHeaderValue})
      this.apiHeaderName = null
      this.apiHeaderValue = null
      console.log(this.apiHeaders)
    },
    addParam(){
      this.apiParams.push({name:this.apiParamName,value:this.apiParamValue})
      this.apiParamName = null
      this.apiParamValue = null
      console.log(this.apiParams)
    },
    deleteColumn(index){
      this.gsheetcolumns.splice(index,1)
      this.gsheetcolumnNames.splice(index,1)
      console.log(this.gsheetcolumnNames)
    },
    deleteHeader(index){
      this.apiHeaders.splice(index,1)
    },
    deleteParam(index){
      this.apiParams.splice(index,1)
    }
  },
  computed:{
      responsename(){
      let index = this.$store.state.currentResponseIndex
      let rname = this.$store.state.responses[index].name
      return rname   
    },
    snackbar(){
      return this.$store.state.snackbar
    }
  }
}
</script>
